module.exports = {
  name: "天唯士",
  orgCode: "0000",
  serviceUrl: "https://xy.gigtech.cn/service/", 
  
  postUrl: "/service/datahandler.ashx",   
};